<div [style.background-color]="currentColor$ | async" class="sceneContainer">
  <lib-wall-decor-front-scene
    (colorPicked)="currentColor$.next($event)"
    [availableImages]="availableImages"
    [imageRelations]="imageRelations"
    (showPreloader$)="drawInProgress$.next($event)"
    [preset]="preset | async"
    [limitPersonalization]="limitPersonalization"
    (imagesUpdated)="currentImages = $event"
    (currentThumb)="currentThumb = $event"
    [scene]="scenePicked | async"></lib-wall-decor-front-scene>
</div>
<lib-wall-decor-scenes-list (pickedScene)="scenePicked.next($event)" [context]="context"
                            [locked]="drawInProgress$ | async"
                            [rounding]="rounding"
                            [limitPersonalization]="limitPersonalization"
                            [availableImages]="availableImages"
                            [imageRelations]="imageRelations"
                            [imageRatio]="photoRatio"
                            [preconfig]="preset | async"
                            [preConfigValue]="preConfigValue"
                            (closed)="closed.emit()"
                            [type]="type"
                            (save)="save()"
                            [isUpdate]="isUpdate"
                            [usedImages]="currentImages"
                            [lookBookProductConfigId]="currentLookBookConfigId"
                            [contextId]="contextId"></lib-wall-decor-scenes-list>

